import React, { useCallback, useMemo } from "react";

import { graphql, useMutation } from "react-relay";
import { useAlert } from "../../common/Alert";
import { StoreAdminNavigationProp } from "../StoreAdmin/StoreAdminNavigation";
import { IntegrationLogo } from "./components/Logos/Logos";
import { IntegrationInvafreshCreateScreenMutation } from "./__generated__/IntegrationInvafreshCreateScreenMutation.graphql";
import { IntegrationActivateScreen } from "./components/IntegrationActivation";

export const IntegrationInvafreshCreateScreen = (props: {
  navigation: StoreAdminNavigationProp<"IntegrationInvafreshCreate">;
}) => {
  const [value, setValue] = React.useState("");

  const screenHash = useMemo(() => {
    return value.match(/^https:\/\/app\.whywaste\.com\/c\/(.{5,})$/)?.[1];
  }, [value]);

  const isValid = screenHash !== undefined;

  const [create, loading] =
    useMutation<IntegrationInvafreshCreateScreenMutation>(graphql`
      mutation IntegrationInvafreshCreateScreenMutation($screenHash: String!) {
        store {
          activateIntegrationInvafresh(screenHash: $screenHash) {
            id
          }
        }
      }
    `);

  const Alert = useAlert();

  const onCreate = useCallback(() => {
    if (!screenHash) return;

    create({
      onCompleted: (d) => {
        if (d.store.activateIntegrationInvafresh) {
          props.navigation.goBack();
        } else {
          Alert.error(
            "Fel Uppstod",
            "Kunde inte skapa integrationen, kontrollera att du har knappat in rätt URL."
          );
        }
      },
      variables: { screenHash },
    });
  }, [Alert, create, props.navigation, screenHash]);

  return (
    <IntegrationActivateScreen
      onActivate={onCreate}
      isActivating={loading}
      isValid={value.length > 0 && isValid}
      header={
        <IntegrationActivateScreen.Header
          logo={<IntegrationLogo type="upshop" />}
        />
      }
      activation={
        <IntegrationActivateScreen.Input
          value={value}
          onChangeText={setValue}
          type="url"
          placeholder="https://app.whywaste.com/c/xxxxxx_yyyyyyyy"
        />
      }
    />
  );
};
